module.exports = __webpack_public_path__ + "img/person_search_opsz24.4c91f02e.svg";